import { useSelector } from "react-redux";
import {
  qrFramesInitialState,
  qrOptionsInitialState,
  qrSettingsInitialState,
  qrTextInitialState,
} from "../constants/common";

function useQrConfigs() {
  const qrSettings = useSelector((state) => state.qrSettings);
  const qrFrames = useSelector((state) => state.qrFrames);
  const qrOptions = useSelector((state) => state.qrOptions);
  const qrText = useSelector((state) => state.qrText);

  const currentConfigs = {
    ...qrSettings,
    ...qrFrames,
    ...qrOptions,
    ...qrText,
  };
  const initialConfigs = {
    ...qrSettingsInitialState,
    ...qrFramesInitialState,
    ...qrOptionsInitialState,
    ...qrTextInitialState,
  };

  return {
    qrSettingsInitialState,
    qrTextInitialState,
    qrFramesInitialState,
    qrOptionsInitialState,
    initialConfigs,
    currentConfigs,
  };
}

export default useQrConfigs;
